export const jobs = [
    {
      title: 'Senior Research Scientist',
      department: 'rnd',
      location: 'Chh. Sambhajinagar',
      type: 'Full-time',
      posted: 'Posted 2 days ago',
      description: 'Lead our pharmaceutical research team in developing innovative formulations for women\'s health products. PhD in Pharmaceutical Sciences with 5+ years experience required.'
    },
    {
      title: 'Product Manager',
      department: 'marketing',
      location: 'Mumbai',
      type: 'Full-time',
      posted: 'Posted 1 week ago',
      description: 'Develop and execute marketing strategies for our gynecare product line. MBA with 3+ years pharmaceutical marketing experience preferred.'
    },
    {
      title: 'Production Supervisor',
      department: 'operations',
      location: 'Pune',
      type: 'Full-time',
      posted: 'Posted 3 days ago',
      description: 'Oversee manufacturing operations ensuring quality and compliance with regulatory standards. B.Pharm with 4+ years production experience required.'
    },
    {
      title: 'Medical Representative',
      department: 'sales',
      location: 'Multiple Locations',
      type: 'Full-time',
      posted: 'Posted 5 days ago',
      description: 'Promote our women\'s health products to healthcare professionals. Science graduate with excellent communication skills and 1+ years pharma sales experience preferred.'
    },
    {
      title: 'Formulation Scientist',
      department: 'rnd',
      location: 'Chh. Sambhajinagar',
      type: 'Full-time',
      posted: 'Posted 1 week ago',
      description: 'Develop and optimize pharmaceutical formulations for new products. M.Pharm with 2+ years formulation experience required.'
    },
    {
      title: 'Quality Assurance Manager',
      department: 'operations',
      location: 'Chh. Sambhajinagar',
      type: 'Full-time',
      posted: 'Posted 2 weeks ago',
      description: 'Ensure all products meet quality standards and regulatory requirements. B.Pharm/M.Pharm with 5+ years QA experience in pharmaceuticals required.'
    },
    {
      title: 'Regional Sales Manager',
      department: 'sales',
      location: 'Maharashtra',
      type: 'Full-time',
      posted: 'Posted 1 day ago',
      description: 'Lead and manage sales team to achieve targets in assigned region. MBA/B.Pharm with 5+ years pharmaceutical sales management experience required.'
    }
  ];